import loadRazorpay from "../utils/loadRazorpay";

export default async function startCheckout({ amount, customer }) {
  // amount in Rupees -> paise
  const paise = Math.max(1, Math.round(amount * 100));

  await loadRazorpay();

  const options = {
    key: process.env.REACT_APP_RAZORPAY_KEY_ID, // test key from .env
    amount: paise,
    currency: "INR",
    name: "Ratna Vastra",
    description: "Order payment",
    image: "/favicon.ico",
    // NOTE: For production, create an order on server and pass order_id here.
    // order_id: "<server-created-order-id>",

    // Prefill (optional)
    prefill: {
      name: customer?.name || "Guest",
      email: customer?.email || "guest@example.com",
      contact: customer?.phone || "9999999999",
    },

    // Theme
    theme: { color: "#3b1c57" },

    // Callback on success
    handler: function (response) {
      // You will get payment info here
      console.log("Payment success:", response);
      alert("Payment successful! Payment ID: " + response.razorpay_payment_id);
      // TODO: Call your backend to verify the signature and mark order as paid.
    },

    // Optional: modal behaviour
    modal: {
      ondismiss: function () {
        console.log("Checkout dismissed");
      },
      escape: true,
      confirm_close: true,
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
}
